import { ChevronUp, ChevronDown } from 'lucide-react';

/**
 * Sortable column header (§9-B): 11px medium label + sort chevron on active column.
 * Inactive columns show a faint hover chevron via CSS group.
 * No uppercase, no vertical dividers.
 */
export function SortableTh<T extends string>({
  label,
  column,
  current,
  asc,
  onSort,
  className,
  cellPaddingClass = 'px-3 h-9 py-0 align-middle',
}: {
  label: string;
  column: T;
  current: T;
  asc: boolean;
  onSort: (col: T) => void;
  className?: string;
  cellPaddingClass?: string;
}) {
  const active = current === column;
  return (
    <th
      className={`${cellPaddingClass} ${className ?? ''}`}
      aria-sort={active ? (asc ? 'ascending' : 'descending') : undefined}
    >
      <button
        type="button"
        className="group/th inline-flex items-center gap-0.5 font-medium vscode-text-secondary hover:vscode-text-primary transition-colors text-left text-[11px]"
        onClick={() => onSort(column)}
      >
        <span>{label}</span>
        {active ? (
          asc ? (
            <ChevronUp className="w-3 h-3 shrink-0 text-emerald-600" aria-hidden />
          ) : (
            <ChevronDown className="w-3 h-3 shrink-0 text-emerald-600" aria-hidden />
          )
        ) : (
          <ChevronDown
            className="w-3 h-3 shrink-0 opacity-0 group-hover/th:opacity-40 transition-opacity"
            aria-hidden
          />
        )}
      </button>
    </th>
  );
}

/**
 * Rightmost header cell for "Add column" affordance (§9-G).
 * Renders a dashed-outline button disabled with tooltip "Coming soon".
 * TODO(§8-v2): wire to attributes manager.
 */
export function EnrichColumnTh({ className }: { className?: string }) {
  return (
    <th className={`px-3 py-0 align-middle ${className ?? ''}`}>
      <button
        type="button"
        disabled
        title="Coming soon"
        className="inline-flex items-center gap-1 rounded border border-dashed border-[var(--vscode-border-primary)] px-2 py-0.5 text-[11px] font-medium vscode-text-tertiary opacity-60 cursor-not-allowed select-none"
      >
        + Enrich column
      </button>
    </th>
  );
}
